import { ScoreCutoffs } from "../models/score-cutoffs.model";

export function getZone(grade: number, systemScore?: number) {
  if (!systemScore) {
    return undefined;
  }
  const studentGroup = grade <= 5 ? 'elementary' : 'secondary';
  const zones = ScoreCutoffs[studentGroup]['zones'];

  // systemScore can be negative. those will be considered zone 1
  return zones.find((z: any) => (z.bottom === 0 || z.bottom <= systemScore) && systemScore < (z.top + 1));
}
